/**
 * Mock no formato de resposta PUDU (pontos do mapa / poses).
 * Substituir por chamada real à API quando disponível.
 */
export const MOCK_NAVIGATION_POSES_RESPONSE = {
    trace_id: '1111111111111111111111',
    message: 'SUCCESS',
    data: {
        total: 5,
        list: [
            {
                name: 'return point 1',
                x: 0.12725049045409734,
                y: 0.008827563986179064,
                z: 0.10761558616086728,
                type: 'return_point',
            },
            {
                name: 'SALA DE REUNIÃO',
                x: 1.204,
                y: -0.332,
                z: 0.101,
                type: 'waypoint',
            },
            {
                name: 'CONHECER O ESCRITÓRIO',
                x: 2.41,
                y: 0.88,
                z: 0.107,
                type: 'waypoint',
            },
            {
                name: 'ÁREA DE DEMONSTRAÇÃO',
                x: -0.55,
                y: 1.12,
                z: 0.107,
                type: 'waypoint',
            },
            {
                name: 'COZINHA',
                x: 0.02,
                y: 2.05,
                z: 0.107,
                type: 'charging_point',
            },
        ],
    },
};
